<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import ModalPictureTextAction from '$components/modal-picture-text-action/ModalPictureTextAction.svelte';
  import Image from '$lib/assets/generic-error.webp';
  import { logoutFromMetri } from '$utils/logoutFromMetri';

  const reload = () => {
    localStorage.clear();
    logoutFromMetri();
    location.href = '/welcome';
  };
</script>

<ModalPictureTextAction>
  {#snippet image()}
    <img src={Image} alt="Metri" />
  {/snippet}
  {#snippet title()}
    Reset Metri
  {/snippet}
  {#snippet paragraph()}
    <p>
      <strong>
        Resetting Metri will clear your app settings and contacts. This can help if you're
        experiencing issues.
      </strong>
    </p>
    <p class="mt-4">
      Your passkey and wallet will remain secure. You won't lose access to your wallet.
    </p>
  {/snippet}
  {#snippet action()}
    <Button ariaLabel="Reset and clear data" variant="danger" onclick={reload}>
      Reset and Clear Data
    </Button>
    <Button ariaLabel="Cancel" variant="secondary" onclick={closeModal}>Cancel</Button>
  {/snippet}
</ModalPictureTextAction>
